import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-nav-item',
  templateUrl: './nav-item.component.html',
  styleUrls: ['./nav-item.component.scss']
})
export class NavItemComponent implements OnInit {
  @Input() iconUrl:string;
  @Input() isForward:boolean=true;
  @Input() isImage: boolean=true;
  constructor() { }

  ngOnInit(): void {
  }

}
